export class UserBankingDataModel {
    bank_account = '';
    account_doctype = '';
    account_doc = '';
    // account_country = '';
    account_firstName = '';
    account_surname1 = '';
    account_surname2 = '';
    // account_birthday = '';
    // account_sex = '';
    account_company = '';
    // account_phone = '';
    // account_email = '';
}
